import api from "../api/axios";

export const fetchUserCountry = async (): Promise<string> => {
  try {
    const response = await api.get(`/geo/country`);
    return response.data?.country;
  } catch (e) {
    return null;
  }
};
